import { select } from '../shared/utils/dom';
import { delimiters } from '../shared/constants';
import { getErrorMessages, getSuccessErrorSecondaryMessage } from './api';
import { createError, removeError } from '../shared/formErrors';
import { isPasswordValid } from '../shared/constants/validation';
import loadingMixin from '../shared/vue/mixins/loading';
import togglePassword from '../shared/vue/mixins/togglePassword';
import scrollUp from '../shared/vue/mixins/scrollUp';

/*
* reset password code
*/
const el = select('[data-vue-app="reset-password"]');
if (el) {
  const app = new Vue({ // eslint-disable-line no-unused-vars
    el,
    mixins: [loadingMixin, scrollUp, togglePassword],
    delimiters,
    data: {
      // for accessibility in live regions
      liveText: '',
      success: false,
      // password
      modelPassword: null,
      // confirm password
      modelConfirmPassword: null,
      // password valid
      modelPasswordValid: false,
      // confirm password matches
      modelConfirmPasswordMatch: false,
      errorMessages: getErrorMessages(), // JSON.parse(document.getElementById('errors').innerHTML),
    },
    computed: {
      shouldBeDisabled() {
        if (this.modelPasswordValid && this.modelConfirmPasswordMatch) {
          return false;
        }
        return true;
      },
    },
    methods: {
      keyUpPassword(event) {
        // password validity check
        if (event.target === this.$refs.password) {
          if (this.modelPassword && this.modelPassword.length < 8) {
            this.modelPasswordValid = false;
          } else if (!isPasswordValid(this.$refs.password.value)) {
            this.modelPasswordValid = false;
          } else {
            this.modelPasswordValid = true;
          }
        }

        // confirm password validity check on initial password input
        if (event.target === this.$refs.password) {
          // check they are the same thing
          if (this.modelConfirmPassword && this.modelPassword && this.modelPasswordValid && this.modelConfirmPassword === this.modelPassword) {
            this.modelConfirmPasswordMatch = true
            removeError(this.$refs.password, this.$refs.passwordError);
          } else {
            this.modelConfirmPasswordMatch = false
            removeError(this.$refs.confirmPassword, this.$refs.confirmPasswordError);
          }
        }

        // confirm password validity check on confirmation input
        if (event.target === this.$refs.confirmPassword) {
          // check they are the same thing
          if (this.modelConfirmPassword && this.modelPassword && this.modelPasswordValid && this.modelConfirmPassword === this.modelPassword) {
            this.modelConfirmPasswordMatch = true
            removeError(this.$refs.password, this.$refs.passwordError);
          } else {
            this.modelConfirmPasswordMatch = false
            removeError(this.$refs.confirmPassword, this.$refs.confirmPasswordError);
          }
        }
      },

      sendResetPassword(event) {
        let hasError = false;

        // validate password fields
        if (!this.modelPassword) {
          createError(this.$refs.password, this.$refs.passwordError, 'Please provide a password.');
          hasError = true
        } else if (!isPasswordValid(this.$refs.password.value)) {
          createError(this.$refs.password, this.$refs.passwordError, getSuccessErrorSecondaryMessage(this.errorMessages, this.$refs.password.dataset.key));
          hasError = true
        } else {
          removeError(this.$refs.password, this.$refs.passwordError);
        }
        // validate confirm password field
        if (!this.modelConfirmPassword) {
          createError(this.$refs.confirmPassword, this.$refs.confirmPasswordError, 'Please confirm password.');
          hasError = true
        } else if (this.modelPassword !== this.modelConfirmPassword) {
          createError(this.$refs.confirmPassword, this.$refs.confirmPasswordError, getSuccessErrorSecondaryMessage(this.errorMessages, this.$refs.confirmPassword.dataset.key));
          hasError = true
        } else {
          removeError(this.$refs.confirmPassword, this.$refs.confirmPasswordError);
        }
        if (hasError) {
          event.preventDefault();
        } else {
          this.loading = true;
          this.hidePasswordText();

          if (window.fabricator) {
            setTimeout(() => {
              this.$refs.formHeadline.style.display = 'none';
              this.$refs.forgotPasswordForm.style.display = 'none';
              this.loading = false;
              this.success = true;
              this.scrollUp();
            }, 500);
          }
        }
      },
    },
  });
}



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/portal/resetPassword.js